import Navigation from "../components/layout/Navigation";
import myPicture from "../assets/img/me.webp";
import { TabTitle } from "../utils/helperFunctions";

//About section component
function About() {
  TabTitle("About");

  return (
    <div
      class="ui container fluid"
      style={{ height: "100vh", backgroundColor: "black" }}
    >
      <Navigation />
      <div
        className="ui two column doubling stackable grid relaxed"
        style={{ padding: "2rem" }}
        id="about"
      >
        <div className="ui column" id="pictureContainer" style={{alignSelf: "center"}}>
          <img
            className="ui image large centered rounded"
            src={myPicture}
            alt={"Michael Wilson being professional"}
          />
        </div>
        <div
          className="ui column padded"
          id="aboutMe"
          style={{ backgroundColor: "black" }}
        >
          <p>
            <span
              className="ui text big"
              style={{
                color: "gold",
                fontWeight: "bold",
              }}
            >
              Michael Wilson
            </span>
          </p>

          <p>
            I am the stand alone owner of MAW Web Services LLC, who is
            constantly learning new skills in regards to{" "}
            <span style={{ textShadow: ".5px .5px yellow" }}>
              Website Setup, Maintenance, Design & Consulting
            </span>
            . I have been involved with Web Development and Programming since
            the Spring of 2018, in fact I have an Associate of Arts in Computer
            Information Science from Ozarks Technical Community College - 2019.
          </p>
          <p>
            I originally gained interest for Web Development & Design during a
            previous job I had, managing an online vitamin store through
            WooCommerce. I found it interesting to use tools through wordpress
            to alter the front end of my company's website.
          </p>
          <p>
            I've helped clients with numerous tasks that they did not have the
            knowledge or resources for. I've assisted with making additions to
            their Content Management Systems, Improving Website Performance by
            fixing issues that PageSpeed Insights reports, Redesign of a website
            through Register.com site builder.
          </p>
          <p>
            If you're needing support with setting up a portfoilo, a blog or
            something even a bit small scale, I can help you with that. If you
            need assistance with redesigning your site or trying to fix a
            problem with your code, or even need someone to make small updates
            to your code base,{" "}
            <a id="contactMe" style={{ color: "#6dffff" }} href="/contact">
              Contact Me
            </a>{" "}
            today for a free consultation.
          </p>
          <div id="iconsContainer">
            <a
              href="https://www.linkedin.com/in/michael-wilson-6a2a5b18a/"
              target="_blank"
              rel="noreferrer"
              aria-label="Checkout my Linkedin Profile "
            >
              <img
                className="ui avatar image mini"
                id="aboutAvatar"
                src="img/linkedin.webp"
                alt={"Linked in icon"}
              />
            </a>
            <a
              // id="aboutLink"
              href="https://github.com/outofcontrolmike"
              target="_blank"
              rel="noreferrer"
              style={{ color: "white" }}
              aria-label="Checkout my Github Profile "
            >
              <i className="github icon white big" id="githubIcon"></i>
            </a>
            <a // id="aboutLink"
              href="https://mwportfolio.online"
              target="_blank"
              rel="noreferrer"
              style={{ color: "white" }}
              aria-label="Click here if you want to contact me via email"
            >
              <i class="file outline icon white big" id="githubIcon"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
